// extracted by mini-css-extract-plugin
module.exports = {"body":"_G7SGLZc","button":"_3pjKF17"};